import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import TopNavbar from "../../top-navbar/TopNav";
import Sidebar from "../Sidebar";
import "./UtilityBillUpload.css";
import { uploadUtilityBill } from "../../../services/employee/api";

export default function UtilityBillUpload() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const validateFile = (file) => {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
    ];
    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (!allowedTypes.includes(file.type)) {
      alert("Only PDF, JPG, and PNG files are allowed.");
      return false;
    }
    if (file.size > maxSize) {
      alert("File size must be less than 5 MB.");
      return false;
    }
    return true;
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && validateFile(selectedFile)) {
      setFile(selectedFile);
    } else {
      e.target.value = "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      alert("Please upload an electricity bill file.");
      return;
    }

    const token = localStorage.getItem("bgc_token");
    if (!token) {
      setError("Authentication token not found. Please log in.");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await uploadUtilityBill(formData);
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="utility-page">
      <Sidebar />

      <div className="utility-container">
        <TopNavbar />
        <div className="utility-card">
          <button
            className="back-btn"
            onClick={() => navigate("/employee/aiModules")}
          >
            ← Back
          </button>

          <h2 className="title">Electricity Bill Verification</h2>

          <form onSubmit={handleSubmit} className="form">
            <div className="file-group">
              <label className="file-label">
                Upload Electricity Bill (PDF, JPG, PNG)
              </label>
              <label className="custom-file-upload">
                {file ? file.name : "Choose a file"}
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={handleFileChange}
                />
              </label>
            </div>

            <button type="submit" className="btn" disabled={loading}>
              {loading ? "Fetching..." : "Fetch Details"}
            </button>
          </form>

          {result && (
            <div className="result-card success">
              <h3>Electricity Bill Details</h3>
              <div className="result-item">
                <span className="label">Bill Type:</span>
                <span className="value">{result.billType || "Unknown"}</span>
              </div>
              <div className="result-item">
                <span className="label">Name:</span>
                <span className="value">{result.name || "—"}</span>
              </div>
              <div className="result-item">
                <span className="label">Address:</span>
                <span className="value">{result.address || "—"}</span>
              </div>
              <div className="result-item">
                <span className="label">Geotag:</span>
                <span className="value">{result.geotag || "—"}</span>
              </div>
              <div className="result-item">
                <span className="label">File Path:</span>
                <span className="value">{result.filePath || "—"}</span>
              </div>
            </div>
          )}

          {error && (
            <div className="result-card error">
              ❌{" "}
              {typeof error === "string"
                ? error
                : JSON.stringify(error, null, 2)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
